import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=17401124&scoped=true"
import script from "./SkeletonLoader.vue?vue&type=script&lang=js"
export * from "./SkeletonLoader.vue?vue&type=script&lang=js"
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=17401124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17401124",
  null
  
)

export default component.exports